module.exports = __webpack_public_path__ + "static/media/satara_Mandave.ef52f2d0.JPG";